<template>
  <div style="margin: 0px; padding: 0px; height: 30px;">
    <div
      v-if="info.ios" 
      class="dn-btn btn-ibooks md-raised"
      @click="downApp('ios')"
    />
    <div
      v-if="info.android" 
      class="dn-btn btn-google md-raised"
      @click="downApp('android')"
    />
    <div
      v-if="!(info.ios || info.android)"
      class="md-body-2 book-title"
      style="font-size: 15px;font-weight: bold;"
    >
      {{ desc[downLang] }}
    </div>
  </div>
</template>

<script>
import globals from '../globals'

export default {
  name: 'DownButton',
  props: {
    downLang: {
      type: String,
      required: true
    },
    downInfo: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    desc:{
      ko: '곧 출간 예정입니다.',
      en: 'Published soon.',
      jp: 'すぐに出版する予定です。'
    }
  }),
  computed : {
    info () {
      return {
        ios: this.$props.downInfo.ios ? globals.get('ibooks') + this.$props.downInfo.ios : '',
        android: this.$props.downInfo.android ? globals.get('googlePlay') + this.$props.downInfo.android : ''
      }
    }
  },
  methods: {
    downApp (type) {
      if (this.info[type]) {
        window.open(this.info[type]);
      }
    }
  }
}
</script>
<style>
  .dn-btn-wrapper {
    position: absolute;
    bottom: 0px;
  }
  .dn-btn {
    display: inline-block;
    margin-right: 5px;
    padding: 0px;
    width: 70px;
    height: 30px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    cursor: pointer;
  }
  .btn-google {
    background-image: url("../assets/imgs/google.png");
  }
  .btn-ibooks {
    background-image: url("../assets/imgs/ibooks.jpg");
  }
</style>